import * as React from "react";
import { Button, DataListAction, DataListCell, DataListItem, DataListItemCells, DataListItemRow } from "@patternfly/react-core";
import { Dropdown, DropdownItem, DropdownList, MenuToggle } from "@patternfly/react-core";
import { EllipsisVIcon, EnterpriseIcon, EyeIcon } from "@patternfly/react-icons";

export const OrganizationDataListItem = ({ organization = null, isOpen, setIsOpen, onSelect, onToggle, onEdit, onView }) => {

  return (
    <DataListItem key={organization?.id} aria-labelledby={organization?.id}>
      <DataListItemRow>
        <DataListItemCells
          dataListCells={[
            <DataListCell key="icon" isIcon>
              <EnterpriseIcon />
            </DataListCell>,
            <DataListCell key="name" isFilled>
              <Button size="sm" variant="link" isInline onClick={() => onView(organization?.id)}>{organization?.name}</Button>
            </DataListCell>
          ]}
        />
        <DataListAction isPlainButtonAction>
          <Dropdown
            popperProps={{ position: 'right' }}
            onOpenChange={(isOpen) => { isOpen ? setIsOpen(organization?.id) : setIsOpen(0) }}
            onSelect={ onSelect }
            isOpen={(isOpen === organization?.id)}
            toggle={(toggleRef) => (
              <MenuToggle
                ref={toggleRef}
                isExpanded={isOpen === organization?.id}
                onClick={() => onToggle(organization?.id)}
                variant="plain"
                aria-label="Organization Action Menu"
              >
                <EllipsisVIcon aria-hidden="true" />
              </MenuToggle>
            )}
          >
            <DropdownList>
            <DropdownItem key="view" icon={<EyeIcon />} onClick={() => onView(organization?.id)}>View</DropdownItem>
{/* 
              <DropdownItem key="edit" icon={<EditIcon />} onClick={() => onEdit(organization?.id)}>Edit</DropdownItem>
              <Divider key="sep1"></Divider>
              <DropdownItem key="delete" icon={<TimesIcon />} onClick={() => onDelete(organization?.id)}>Delete</DropdownItem>
 */}
            </DropdownList>
          </Dropdown>
        </DataListAction>
      </DataListItemRow>
    </DataListItem>
  );

};
